export default "__VITE_ASSET__CFQdtdpo__"